import {
  DealEndInfoContainer,
  KeyDetailsList,
  KeyDetailsListItem,
  KeyDetailsWithSubText,
  SubTextSmall,
} from "pages/Application/Recommendation/Recommendation.styles"
import React from "react"

interface MortgageDealPeriodSectionProps {
  mortgageEndsBeforeProduct: boolean
  productEndDate: string
  followOnMonthlyRate: number
  formattedFollowOnMonthlyPayment: string
}

const formatProductEndDate = (date: Date) => {
  const month = date.toLocaleString("default", { month: "short" })
  const year = date.getFullYear()
  return `${month} ${year}`
}

export const MortgageDealPeriodSection = ({
  mortgageEndsBeforeProduct,
  productEndDate,
  followOnMonthlyRate,
  formattedFollowOnMonthlyPayment,
}: MortgageDealPeriodSectionProps) => {
  return (
    <DealEndInfoContainer>
      {mortgageEndsBeforeProduct ? (
        <KeyDetailsList>
          <KeyDetailsListItem>
            <KeyDetailsWithSubText>
              <div>
                <span>You'll have repaid the whole of your mortgage</span>
              </div>
              <SubTextSmall>
                Congratulations! Your mortgage will be repaid by the time this deal ends.
              </SubTextSmall>
            </KeyDetailsWithSubText>
          </KeyDetailsListItem>
        </KeyDetailsList>
      ) : (
        <>
          <KeyDetailsList>
            <KeyDetailsListItem>
              <KeyDetailsWithSubText>
                <div>
                  <span>Deal end date</span>
                  <span>{formatProductEndDate(new Date(productEndDate))}</span>
                </div>
                <SubTextSmall>
                  At this point you will be moved onto the standard variable rate.
                </SubTextSmall>
              </KeyDetailsWithSubText>
            </KeyDetailsListItem>
            <KeyDetailsListItem>
              <span>Standard variable rate (SVR)</span>
              <span>{followOnMonthlyRate}%</span>
            </KeyDetailsListItem>
            <KeyDetailsListItem>
              <span>Monthly payments after initial period</span>
              <span>£{formattedFollowOnMonthlyPayment}</span>
            </KeyDetailsListItem>
          </KeyDetailsList>
        </>
      )}
    </DealEndInfoContainer>
  )
}
